import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";

import {
  selectAnnexeListFileName,
  selectAnnexeListCategory,
  selectAnnexeListYear,
  selectAnnexeType,
  setAnnexeList,
  setAnnexeAttachment
} from "Actions";
import {
  fetchAnnexeList,
  fetchAnnexeCategorySuggestions,
  deleteAnnexe,
  setMainAnnexe,
  toggleHiddenAnnexe,
  saveAnnexes,
  toggleCertifiedAnnexe
} from "Thunks";
import { DOCUMENT_TYPE } from "Config";
import { onSuccess, onError, dateFormat, isFiduciaryAccess } from "Utils";

import { TiWarningOutline, TiArrowSortedDown } from "react-icons/ti";
import { ICONS, SvgIcon, HideEye } from "../Common/Icons";
import { Switch, Tooltip } from "antd";
import NotFoundV2 from "../NotFound/NotFoundV2";
import AddAnnexeSideBar from "./AddAnnexeSideBar";

import styles from "./BalanceSheet.local.scss";
import { ModalConfirm } from "tamtam-components";

class AnnexeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainLoading: false,
      hiddenLoading: false,
      AnnexeToUpdate: null,
      isAddingAnnexe: false,
      loadingUploadAnnexe: false,
      certifiedLoading: false,
      categoriesFilterIsVisible: false,
      yearsFilterIsVisible: false,
      types: [],
      categories: [],
      isOpenModalDelete: false,
      annexeId: null
    };
  }

  componentDidMount() {
    let { lng } = this.props;
    let newTypes = [...DOCUMENT_TYPE];
    this.props
      .dispatch(fetchAnnexeCategorySuggestions({ lng }))
      .then(res => {
        const categories = res.value.data.data.map(t => {
          return { value: t.id, label: t.label[lng] };
        });
        let otherCategories = res.value.data.data.filter(
          t => t.label.en === "Others"
        );
        newTypes.push(
          otherCategories.map(t => {
            return { value: t.id, label: "annexes", code: "ANNEXES" };
          })[0]
        );
        newTypes.push(
          otherCategories.map(t => {
            return { value: t.id, label: t.label[lng], code: "OTHERS" };
          })[0]
        );
        categories.unshift({ value: null, label: "allCategories" });
        this.setState({ categories, types: newTypes });
      })
      .catch(er => {
        this.setState({
          error: true,
          loading: false
        });
      });

    document.addEventListener(
      "mousedown",
      this.handleClickOutsideCategoriesSelect.bind(this)
    );
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearsSelect.bind(this)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      filter: { fileName, category, year, type }
    } = prevProps;
    const { filter } = this.props;
    if (
      (fileName !== filter.fileName &&
        (filter.fileName.length > 2 || filter.fileName.length === 0)) ||
      category !== filter.category ||
      year !== filter.year ||
      type !== filter.type
    ) {
      this.props.dispatch(fetchAnnexeList());
    }
  }

  componentWillUnmount(): void {
    this.props.closeAnnexePDF();
  }

  //********* Header functions **********//
  renderAnnexesListHeader = () => {
    let { fileName } = this.props.filter;
    return (
      <div className={styles.list_section_header}>
        <div className={styles.label}>{_("files")}</div>
        <div style={{ display: "flex" }}>
          <div className="search-box" style={{ width: 300 }}>
            <span className="search-box__icon">
              <img src="/img/icons/search.svg" alt="" />
            </span>
            <input
              value={fileName ? fileName : ""}
              style={{ width: 250 }}
              placeholder={`${_("search")} ...`}
              onChange={event => this.handleSearchInputChange(event)}
            />
          </div>
        </div>
      </div>
    );
  };

  handleSearchInputChange(event) {
    const { dispatch } = this.props;
    if (event.target.value) {
      dispatch(selectAnnexeListFileName(event.target.value));
    } else {
      dispatch(selectAnnexeListFileName(""));
    }
  }

  //********* Filter functions **********//
  renderAnnexesListFilter = () => {
    const {
      accountingYears,
      filter: { category, year, type }
    } = this.props;
    let {
      categoriesFilterIsVisible,
      yearsFilterIsVisible,
      categories,
      types
    } = this.state;

    let years = accountingYears.map(value => {
      return { label: value, value: value };
    });
    years.unshift({ value: null, label: "all" });

    return (
      <div className={styles.list_section_filter}>
        <div className={styles.tabs}>
          {types.map((element, i) => {
            return (
              <div
                key={i}
                className={
                  styles.tab_badge +
                  " " +
                  (type && element && type.label === element.label
                    ? styles.tab_badge_active
                    : "")
                }
                onClick={() => this.handleSelectDocumentType(element)}
              >
                {element && _(element.label)}
              </div>
            );
          })}
        </div>
        <div className={styles.selects}>
          <div
            ref={this.setCategoriesWrapperRef.bind(this)}
            className={styles.customed_select}
            style={{ width: 220 }}
          >
            <div className={styles.customed_select_header}>
              <span>{_(category.label)}</span>
              <div className={styles.actions}>
                <div>
                  <span
                    className={styles.action}
                    onClick={this.handleDisplayCategoriesFilter}
                  >
                    <TiArrowSortedDown />
                  </span>
                </div>
              </div>
            </div>
            {categoriesFilterIsVisible && (
              <div className={styles.customed_select_body}>
                <div className={styles.customed_select_body_options}>
                  {categories.map((item, index) => (
                    <div
                      key={index}
                      className={styles.customed_select_body_option}
                      onClick={() => this.handleCategoriesChange(item)}
                    >
                      {_(item.label)}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div
            ref={this.setYearsWrapperRef.bind(this)}
            className={styles.customed_select}
          >
            <div className={styles.customed_select_header}>
              <span>{_(year.label)}</span>
              <div className={styles.actions}>
                <div>
                  <span
                    className={styles.action}
                    onClick={this.handleDisplayYearsFilter}
                  >
                    <TiArrowSortedDown />
                  </span>
                </div>
              </div>
            </div>
            {yearsFilterIsVisible && (
              <div className={styles.customed_select_body}>
                <div className={styles.customed_select_body_options}>
                  {years.map((item, index) => (
                    <div
                      key={index}
                      className={styles.customed_select_body_option}
                      onClick={() => this.handleYearsChange(item)}
                    >
                      {_(item.label)}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  setCategoriesWrapperRef = node => {
    this.categoriesWrapperRef = node;
  };

  setYearsWrapperRef = node => {
    this.yearsWrapperRef = node;
  };

  handleClickOutsideCategoriesSelect(event) {
    if (
      this.categoriesWrapperRef &&
      !this.categoriesWrapperRef.contains(event.target)
    ) {
      this.setState({ categoriesFilterIsVisible: false });
    }
  }

  handleClickOutsideYearsSelect(event) {
    if (this.yearsWrapperRef && !this.yearsWrapperRef.contains(event.target)) {
      this.setState({ yearsFilterIsVisible: false });
    }
  }

  handleDisplayCategoriesFilter = () => {
    this.setState(state => {
      return {
        categoriesFilterIsVisible: !state.categoriesFilterIsVisible
      };
    });
  };

  handleDisplayYearsFilter = () => {
    this.setState(state => {
      return {
        yearsFilterIsVisible: !state.yearsFilterIsVisible
      };
    });
  };

  handleSelectDocumentType = type => {
    this.props.dispatch(selectAnnexeType(type));
  };

  handleCategoriesChange = category => {
    this.props.dispatch(selectAnnexeListCategory(category));
    this.setState({ categoriesFilterIsVisible: false });
  };

  handleYearsChange = year => {
    this.props.dispatch(selectAnnexeListYear(year));
    this.setState({ yearsFilterIsVisible: false });
  };

  //********* List functions **********//
  handleSetMainAnnexe = annexe => {
    const { dispatch, annexesData, organization } = this.props;

    let annexesList = annexesData;

    this.setState({ mainLoading: true, annexeToUpdate: annexe.id });

    dispatch(setMainAnnexe(annexe.id, organization.uen)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("mainAnnexeUpdated")
        });

        this.setState({ mainLoading: false, annexeToUpdate: null });

        // eslint-disable-next-line array-callback-return
        annexesList.map((item, i) => {
          if (
            item.category.id === annexe.category.id &&
            item.year === annexe.year &&
            item.main === 1
          ) {
            annexesList[i].main = 0;
          } else if (item.id === annexe.id) {
            annexesList[i].main = 1;
          }
        });
        dispatch(setAnnexeList(annexesList));
      },
      err => {
        onError(err.response.data.errors[0].message);
        this.setState({ mainLoading: false, annexeToUpdate: null });
      }
    );
  };

  handleToggleHiddenAnnexe = annexe => {
    const { dispatch, annexesData, organization } = this.props;

    let annexesList = annexesData;

    this.setState({ hiddenLoading: true, annexeToUpdate: annexe.id });

    dispatch(toggleHiddenAnnexe(annexe.id, organization.uen)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("hiddenAnnexeUpdated")
        });

        this.setState({ hiddenLoading: false, annexeToUpdate: null });

        // eslint-disable-next-line array-callback-return
        annexesList.map((item, i) => {
          if (item.id === annexe.id) {
            annexesList[i].hidden = annexe.hidden ? 0 : 1;
          }
        });
        dispatch(setAnnexeList(annexesList));
      },
      err => {
        onError(err.response.data.errors[0].message);
        this.setState({ hiddenLoading: false, annexeToUpdate: null });
      }
    );
  };

  handleToggleCertifiedAnnexe = annexe => {
    const { dispatch, annexesData, organization } = this.props;

    let annexesList = annexesData;

    this.setState({ certifiedLoading: true, annexeToUpdate: annexe.id });

    dispatch(toggleCertifiedAnnexe(annexe.id, organization.uen)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("certifiedAnnexeUpdated")
        });

        this.setState({ certifiedLoading: false, annexeToUpdate: null });

        // eslint-disable-next-line array-callback-return
        annexesList.map((item, i) => {
          if (item.id === annexe.id) {
            annexesList[i].certified = annexe.certified ? 0 : 1;
          }
        });
        dispatch(setAnnexeList(annexesList));
      },
      err => {
        onError(err.response.data.errors[0].message);
        this.setState({ certifiedLoading: false, annexeToUpdate: null });
      }
    );
  };

  handleDeleteAnnexe = annexeId => {
    this.setState({ isOpenModalDelete: true });
    this.setState({ annexeId: annexeId });
  };

  onClickNewAnnexe = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    // document.getElementById("mainMenu").style.zIndex = 6;
    // document.body.style.overflow = "hidden";
    document.body.classList.add("hidden_overflow");

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.setState({ isAddingAnnexe: true });
  };

  onCancelNewAnnexe = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    // document.getElementById("mainMenu").style.zIndex = 4;
    // document.body.style.removeProperty("overflow");
    document.body.classList.remove("hidden_overflow");

    this.setState({
      isAddingAnnexe: false
    });
    this.props.dispatch(setAnnexeAttachment(null));
  };

  handleSaveAnnexes = annexes => {
    this.setState({ loadingUploadAnnexe: true });
    this.props.dispatch(saveAnnexes(annexes, this.props.organization.uen)).then(
      res => {
        this.setState({ loadingUploadAnnexe: false });
        onSuccess(res, {
          body: _("importAnnexeSuccess"),
          title: _("importSuccess")
        });
        this.onCancelNewAnnexe();
        this.props.dispatch(fetchAnnexeList());
      },
      error => {
        this.setState({ loadingUploadAnnexe: false });
        onError(
          error.response && error.response.data.errors
            ? error.response.data.errors[0].message
            : "errorOccured"
        );
      }
    );
  };

  //********* Sidebar functions **********//
  renderAddBubble = () => {
    const { isAddingAnnexe } = this.state;
    return (
      <div className="setting-bubbles">
        <div
          className={classnames(
            "circleSvg",
            isAddingAnnexe ? "active openedAddAnnexeSideBar" : ""
          )}
          onClick={() => this.onClickNewAnnexe()}
        >
          <SvgIcon icon={"AddIcon"} />
          <span style={{ paddingLeft: "2.5rem" }}>{_("add")}</span>
        </div>
      </div>
    );
  };

  renderEtatAnnexeFiduciary = item => {
    const { mainLoading, annexeToUpdate, certifiedLoading } = this.state;
    return (
      <div
        className={styles.etat_annexe}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div className={styles.etat_block}>
          <span>{_("certified")}</span>
          <Switch
            checked={item.certified}
            onChange={() => this.handleToggleCertifiedAnnexe(item)}
            checkedChildren={
              annexeToUpdate === item.id && certifiedLoading ? (
                <img
                  src={"/img/icons/tail-spin.svg"}
                  alt={""}
                  className={styles.checkedChildren}
                />
              ) : (
                ""
              )
            }
            unCheckedChildren={
              annexeToUpdate === item.id && certifiedLoading ? (
                <img
                  src={"/img/icons/tail-spin.svg"}
                  alt={""}
                  className={styles.unCheckedChildren}
                />
              ) : (
                ""
              )
            }
          />
        </div>
        <div className={styles.etat_block} style={{ width: "47%" }}>
          <span>{_("main")}</span>
          <Switch
            checked={item.main}
            onChange={() => {
              //   if (item.main === 0) {
              this.handleSetMainAnnexe(item);
              //   }
            }}
            checkedChildren={
              annexeToUpdate === item.id && mainLoading ? (
                <img
                  src={"/img/icons/tail-spin.svg"}
                  alt={""}
                  className={styles.checkedChildren}
                />
              ) : (
                ""
              )
            }
            unCheckedChildren={
              annexeToUpdate === item.id && mainLoading ? (
                <img
                  src={"/img/icons/tail-spin.svg"}
                  alt={""}
                  className={styles.unCheckedChildren}
                />
              ) : (
                ""
              )
            }
          />
        </div>
      </div>
    );
  };

  renderVisibilityClientAnnexeFiduciary = item => {
    const { annexeToUpdate, hiddenLoading } = this.state;

    return (
      <div className={styles.actions}>
        <div>
          <span>{item.hidden ? _("hidden") : _("visible")}</span>
          {item.hidden ? (
            <Tooltip placement="bottom" title={_("makeVisible")}>
              <span
                className={classnames(styles.action, styles.hidden_action)}
                onClick={event => {
                  event.stopPropagation();
                  this.handleToggleHiddenAnnexe(item);
                }}
              >
                {annexeToUpdate === item.id && hiddenLoading ? (
                  <img
                    src={"/img/icons/tail-spin.svg"}
                    alt={""}
                    className={styles.loading}
                  />
                ) : (
                  <HideEye className={classnames(styles.hidden)} />
                )}
              </span>
            </Tooltip>
          ) : (
            <Tooltip placement="bottom" title={_("hide")}>
              <span
                className={classnames(styles.action, styles.visible_action)}
                onClick={event => {
                  event.stopPropagation();
                  this.handleToggleHiddenAnnexe(item);
                }}
              >
                {annexeToUpdate === item.id && hiddenLoading ? (
                  <img
                    src={"/img/icons/tail-spin.svg"}
                    alt={""}
                    className={styles.loading}
                  />
                ) : (
                  <SvgIcon
                    icon={ICONS.EyeIcon}
                    className={classnames(styles.visible)}
                  />
                )}
              </span>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  renderDeleteActionFiduciary = item => {
    return (
      <div className={styles.actions}>
        <div style={{ paddingLeft: 0, width: "100%", paddingRight: 0 }}>
          <Tooltip placement="bottom" title={_("delete")}>
            <span
              className={styles.action}
              onClick={event => {
                event.stopPropagation();
                this.handleDeleteAnnexe(item.id);
              }}
            >
              <SvgIcon icon={ICONS.Garbage} className={styles.delete} />
            </span>
          </Tooltip>
        </div>
      </div>
    );
  };

  //  *************         FIDUCIARY      ******************//
  renderFiduciaryAccessAnnexeList = () => {
    const { annexesData, lng } = this.props;
    return (
      <table className={styles.annexe_table}>
        <thead key={"thead"}>
          <tr>
            <th width={165}>{_("importedAt")}</th>
            <th width={335}>{_("fileName")}</th>
            <th width={82}>{_("exercise")}</th>
            <th width={190}>{_("category")}</th>
            <th width={250}>{_("annexState")}</th>
            <th width={125}>{_("clientVisibility")}</th>
          </tr>
        </thead>

        <tbody key={"tbody"}>
          {annexesData.map((item, i) => {
            return (
              <tr
                key={`annexe-${i}`}
                onClick={() =>
                  this.props.displayAnnexePDF(item.id, item.filePath)
                }
              >
                <td>{dateFormat(item.createdAt, lng)}</td>
                <td>{item.fileName}</td>
                <td>{item.year}</td>
                <td>{item.category.label[lng]}</td>
                <td>{this.renderEtatAnnexeFiduciary(item)}</td>
                <td>{this.renderVisibilityClientAnnexeFiduciary(item)}</td>
                <td width={36}>{this.renderDeleteActionFiduciary(item)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  //  *************         CLIENT      ******************//
  renderClientAccessAnnexeList = () => {
    const { annexesData, lng } = this.props;
    return (
      <table className={styles.annexe_table}>
        <thead key={"thead"}>
          <tr>
            <th width={165}>{_("importedAt")}</th>
            <th width={480}>{_("fileName")}</th>
            <th width={82}>{_("exercise")}</th>
            <th width={190}>{_("category")}</th>
            <th width={250}>{_("annexState")}</th>
          </tr>
        </thead>

        <tbody key={"tbody"}>
          {annexesData.map((item, i) => {
            return (
              <tr
                key={`annexe-${i}`}
                onClick={() =>
                  this.props.displayAnnexePDF(item.id, item.filePath)
                }
              >
                <td>{dateFormat(item.createdAt, lng)}</td>
                <td>{item.fileName}</td>
                <td>{item.year}</td>
                <td>{item.category.label[lng]}</td>
                <td>{this.renderAnnexeStatesTags(item)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  renderAnnexeStatesTags = item => {
    return (
      <div className={styles.annexe_tags}>
        {item.certified ? (
          <span className={styles.tag}>{_("certified")}</span>
        ) : (
          ""
        )}
        {item.main ? <span className={styles.tag}>{_("Main")}</span> : ""}
      </div>
    );
  };

  render() {
    const {
      error,
      annexeStat: { fetching, fetched },
      annexesData,
      currentOrganization,
      dispatch
    } = this.props;
    const {
      isAddingAnnexe,
      loadingUploadAnnexe,
      isOpenModalDelete,
      annexeId
    } = this.state;

    return (
      <div className={styles.list_section}>
        {this.renderAnnexesListHeader()}
        {fetching ? (
          <div className={styles.ripple_loading_adapted}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        ) : error ? (
          <div className={styles.empty_frame}>
            <TiWarningOutline />
            <span>{_("Oups")}</span>
          </div>
        ) : (
          <Fragment>
            {this.renderAnnexesListFilter()}
            {fetched && annexesData.length === 0 && <NotFoundV2 />}
            {fetched &&
              annexesData.length > 0 &&
              (isFiduciaryAccess(currentOrganization)
                ? this.renderFiduciaryAccessAnnexeList()
                : this.renderClientAccessAnnexeList())}
          </Fragment>
        )}
        {isFiduciaryAccess(currentOrganization) &&
          fetched &&
          this.renderAddBubble()}
        {isFiduciaryAccess(currentOrganization) &&
          fetched && (
            <AddAnnexeSideBar
              saving={loadingUploadAnnexe}
              isAddingAnnexe={isAddingAnnexe}
              onCancelNewAnnexe={this.onCancelNewAnnexe}
              handleSaveAnnexes={this.handleSaveAnnexes}
            />
          )}
        {/*<AnnexeIframe*/}
        {/*  hideIframe={this.state.hideIframe}*/}
        {/*  srcIframe={this.props.temporaryFileLink.link}*/}
        {/*  loadingIframe={this.state.loadingIframe}*/}
        {/*  onCloseIframe={this.closeAnnexePDF}*/}
        {/*/>*/}

        <ModalConfirm
          type={"delete"}
          isOpen={isOpenModalDelete}
          onCancel={() => this.setState({ isOpenModalDelete: false })}
          onConfirm={() => {
            let annexesList = annexesData;
            return new Promise((resolve, reject) => {
              dispatch(deleteAnnexe(annexeId)).then(
                res => {
                  onSuccess(res, {
                    title: _("removeSuccess"),
                    body: _("annexeDeleted")
                  });
                  resolve(true);

                  dispatch(
                    setAnnexeList(
                      annexesList.filter(({ id }) => id !== annexeId)
                    )
                  );
                  this.setState({ isOpenModalDelete: false });
                },
                err => {
                  onError(err.response.data.errors[0].message);
                  reject(true);
                }
              );
            }).catch(() => console.log("Oops errors!"));
          }}
          inProcess={false}
          actionFailed={false}
          title={_("deleteConfirmation")}
          text={_("deleteAnnexeContent")}
          labelNo={_("cancel")}
          labelYes={_("Delete")}
          labelError={"Error"}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.balanceSheet.error,
  organization: state.balanceSheet.organization,
  activeModel: state.balanceSheet.model,
  currentOrganization: state.auth.currentOrganization,
  annexesData: state.annexes.annexesList.items,
  annexeStat: state.annexes.annexesList,
  filter: state.annexes.annexesList.filter,
  accountingYears:
    (state.balanceSheet.balanceSheetData &&
      state.balanceSheet.balanceSheetData.years) ||
    [],
  temporaryFileLink: state.annexes.annexesList.temporaryFileLink,
  lng: state.params.lng,
  token: state.auth.token
});

export default connect(mapStateToProps)(AnnexeList);



// WEBPACK FOOTER //
// ./src/components/BalanceSheet/AnnexeList.js